import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoverhoundComponent } from './coverhound.component';
import { RouterModule } from '@angular/router';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';

@NgModule({
    declarations: [CoverhoundComponent],
    imports: [CommonModule, RouterModule, AppAnalyticsModule],
    exports: [CoverhoundComponent],
})
export class CoverhoundModule {}
